import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-row flex between-xs middle-xs" }
const _hoisted_2 = { class: "regular black" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "card-row flex between-xs middle-xs" }
const _hoisted_5 = { class: "card-term flex middle-xs" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "regular black" }
const _hoisted_8 = { class: "cvv-wrapper" }
const _hoisted_9 = {
  key: 1,
  class: "loading flex middle-xs center-xs"
}
const _hoisted_10 = { class: "row middle-xs" }
const _hoisted_11 = { class: "col-xs-6" }
const _hoisted_12 = {
  key: 0,
  class: "regular red"
}
const _hoisted_13 = { class: "col-xs-6 end-xs" }
const _hoisted_14 = { class: "regular black" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-xs-12 align-right" }
const _hoisted_17 = { class: "loading-content" }
const _hoisted_18 = { class: "regular black" }
const _hoisted_19 = { class: "loading-spinner" }
const _hoisted_20 = { class: "booking-success align-center" }
const _hoisted_21 = { class: "booking-success-text" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("svg", {
  width: "52",
  height: "52",
  viewBox: "0 0 52 52"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    fill: "none",
    "fill-rule": "evenodd",
    transform: "translate(2 2)"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M6.857 6.857h33.758v33.758H6.857z" }),
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#5E06B6",
      "fill-rule": "nonzero",
      d: "M19.516 29.602l-5.865-5.866-1.997 1.984 7.862 7.862 16.88-16.879-1.984-1.983z"
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "24",
      cy: "24",
      r: "24",
      stroke: "#5E06B6",
      "stroke-width": "3"
    })
  ])
], -1)
const _hoisted_23 = { class: "black medium" }
const _hoisted_24 = { class: "black regular" }
const _hoisted_25 = ["href"]
const _hoisted_26 = { class: "booking-success-action row" }
const _hoisted_27 = { class: "col-xs-12 end-xs" }

import { computed, ComputedRef, WritableComputedRef } from 'vue';
  import { useStore } from 'vuex';
  import { useI18n } from 'vue-i18n';
  import { User, Order, HotelOffers, Cars, HotelSearchCriteria } from 'types';
  import ModalComponent from '@/views/components/ModalComponent.vue';
  import ButtonComponent from '@/views/components/ButtonComponent.vue';
  import SpinnerComponent from '@/views/components/SpinnerComponent.vue';
  import InputCvvComponent from '@/views/components/InputCvvComponent.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BookingModalsComponent',
  setup(__props) {

  const store = useStore();
  const { t } = useI18n();

  const guest: ComputedRef<User.Guest> = computed(() => store.state.user.guest);
  const contacts: ComputedRef<User.Contacts> = computed(
    () => store.state.user.contacts,
  );
  const split: ComputedRef<User.Split> = computed(() => store.state.user.split);
  const orderDetails: ComputedRef<Order.OrderDetails> = computed(
    () => store.state.booking.orderDetails,
  );
  const successConfirm: ComputedRef<boolean> = computed(
    () => store.state.booking.successConfirm,
  );
  const bookingLoading: ComputedRef<boolean> = computed(
    () => store.state.booking.bookingLoading,
  );
  const confirmDialog: ComputedRef<Order.ConfirmDialog> = computed(
    () => store.state.booking.confirmDialog,
  );
  const failureDialog: ComputedRef<Order.FailureDialog> = computed(
    () => store.state.booking.failureDialog,
  );
  const payment: ComputedRef<User.Card> = computed(
    () => store.state.booking.payment,
  );
  const loadingDialog: ComputedRef<Order.LoadingDialog> = computed(
    () => store.state.booking.loadingDialog,
  );

  const hotelOffer: ComputedRef<HotelOffers.Offer> = computed(
    () => store.state.hotel.selectedOffer,
  );
  const carOffer: ComputedRef<Cars.CarDetails> = computed(
    () => store.state.car.offer,
  );
  const searchCriteria: ComputedRef<HotelSearchCriteria> = computed(
    () => store.state.searchCriteria.criteria,
  );

  const cardnumber: ComputedRef<string> = computed(() =>
    payment.value?.card_mask?.replace(/(?<=^.{6}).*(?=.{4}$)/, match =>
      'x'.repeat(match.length),
    ),
  );

  const cvv: WritableComputedRef<string> = computed({
    get() {
      return confirmDialog.value.cvv;
    },
    set(code: string) {
      store.commit('booking/setCVV', code);
    },
  });

  function cardImage(number: string): string {
    if (number.startsWith('34') || number.startsWith('37')) {
      return 'am-ex';
    } else if (number.startsWith('4')) {
      return 'visa';
    } else if (number.startsWith('5')) {
      return 'master-card';
    } else {
      return 'credit-card';
    }
  }

  function goToUpcomingTrips() {
    window.open(`/profile/trips`);
    showSuccess(false);
  }

  function openOrderDetails() {
    if (localStorage.getItem('view')) {
      window.open('/trips/order', '_self');
    } else {
      if (orderDetails.value.product === Order.OrderProduct.hotel) {
        window.open(`/order/${orderDetails.value.id}`);
      } else {
        window.open(
          `https://workflow-api.finalprice.com/v1/trips/order/${orderDetails.value.id}`,
        );
      }
    }
    showSuccess(false);
  }

  function createOrder() {
    if (carOffer.value) {
      store.dispatch('booking/book', {
        product: Order.OrderProduct.car,
        guest: guest.value,
        contacts: contacts.value,
        planId: split.value.planModel ? split.value.planModel.id : '',
        offer: carOffer.value.source,
      });
    } else if (hotelOffer.value) {
      store.dispatch('booking/book', {
        product: Order.OrderProduct.hotel,
        split: split.value.plan,
        guest: guest.value,
        contacts: contacts.value,
        planId: split.value.planModel ? split.value.planModel.id : '',
        offer: hotelOffer.value,
        criteria: searchCriteria.value,
      });
    }
  }

  function showCVV(show: boolean) {
    store.commit('booking/showCVV', show);
  }
  function showSuccess(show: boolean) {
    store.commit('booking/showSuccess', show);
  }
  function showFailure(show: boolean) {
    store.commit('booking/showFailure', show);
  }

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ModalComponent, {
      type: "prompt",
      state: _unref(confirmDialog).show,
      clickOutside: false,
      class: "enter-security-code-modal",
      onModalClose: _cache[3] || (_cache[3] = ($event: any) => (showCVV(false))),
      "modal-name": "securitycode"
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('hotelpage.securityCodeModal.title')), 1)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_unref(confirmDialog).error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_unref(confirmDialog).error), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(ButtonComponent, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (createOrder())),
              variant: "primary",
              class: "no-shadow",
              enable: !_unref(bookingLoading)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('hotelpage.securityCodeModal.confirmBtn')), 1)
              ]),
              _: 1
            }, 8, ["enable"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        (_unref(payment))
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              class: "card-carcas",
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (createOrder()), ["prevent"]))
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(cardnumber)), 1),
                  _createElementVNode("img", {
                    src: require(`@/assets/img/${cardImage(_unref(payment).card_mask)}.svg`),
                    alt: "card"
                  }, null, 8, _hoisted_3)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_i18n_t, {
                      keypath: "hotelpage.securityCodeModal.cardTerm",
                      tag: "p",
                      class: "regular black",
                      scope: "global"
                    }, {
                      break: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(`${_unref(payment).exp_month}/${_unref(payment).exp_year
                    .toString()
                    .slice(-2)}`), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(InputCvvComponent, {
                      value: _unref(cvv),
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(cvv) ? (cvv).value = $event : null))
                    }, null, 8, ["value"])
                  ])
                ])
              ])
            ], 32))
          : _createCommentVNode("", true),
        (_unref(bookingLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(SpinnerComponent, { width: 39 })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["state"]),
    _createVNode(ModalComponent, {
      class: "booking-error-modal",
      type: "prompt",
      state: _unref(failureDialog).show,
      onModalClose: _cache[5] || (_cache[5] = ($event: any) => (showFailure(false))),
      "modal-name": "booking-error"
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_unref(failureDialog).error), 1)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(ButtonComponent, {
              class: "no-shadow",
              variant: "primary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (showFailure(false)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('hotelpage.failureModal.okBtn')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(failureDialog).message), 1)
      ]),
      _: 1
    }, 8, ["state"]),
    _createVNode(ModalComponent, {
      type: "prompt",
      state: _unref(loadingDialog).show,
      clickOutside: false,
      class: "loading-dialog-modal",
      "modal-name": "loading"
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_unref(loadingDialog).title), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(loadingDialog).message), 1),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(SpinnerComponent, { width: 39 })
          ])
        ])
      ]),
      _: 1
    }, 8, ["state"]),
    _createVNode(ModalComponent, {
      type: "prompt",
      class: "booking-success-modal",
      onModalClose: _cache[8] || (_cache[8] = ($event: any) => (showSuccess(false))),
      state: _unref(successConfirm),
      "modal-name": "success"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createVNode(ButtonComponent, {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (goToUpcomingTrips())),
              variant: "primary",
              class: "no-shadow"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('hotelpage.bookingSuccessModal.okBtn')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("h2", _hoisted_23, _toDisplayString(_unref(t)('hotelpage.bookingSuccessModal.title')), 1),
            _createElementVNode("h3", _hoisted_24, _toDisplayString(_unref(t)('hotelpage.bookingSuccessModal.subtitle')), 1),
            _createVNode(_component_i18n_t, {
              keypath: "hotelpage.bookingSuccessModal.content",
              tag: "p",
              class: "grey regular",
              scope: "global"
            }, {
              mail: _withCtx(() => [
                _createElementVNode("a", {
                  class: "grey",
                  href: `mailto:${_unref(contacts).email}`
                }, _toDisplayString(_unref(contacts).email), 9, _hoisted_25)
              ]),
              _: 1
            })
          ]),
          (_unref(orderDetails))
            ? (_openBlock(), _createBlock(ButtonComponent, {
                key: 0,
                class: "bordered purpure",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (openOrderDetails()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('hotelpage.bookingSuccessModal.orderDetailsBtn')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["state"])
  ]))
}
}

})